export const STOCK_AI_ANALYSIS_TYPES = {
  COMPANY_OVERVIEW: "company_overview",
  COMPANY_ANALYSIS: "company_analysis"
};

export const STOCK_AI_ANALYSIS_STATUS = {
  READY: "analysis_ready",
  REQUESTED: "analysis_requested",
  OUTDATED: "analysis_outdated",
  FAILED: "analysis_failed"
};

export const STOCK_AI_ANALYSIS_VIEW = {
  NOT_AVAILABLE: "not_available",
  ERROR: "error",
  LOADING: "loading",
  CONTENT: "content"
};

export const STOCK_AI_ANALYSIS_POLL_INTERVAL_MS = 5000;
export const STOCK_AI_ANALYSIS_POLL_TIMEOUT_MS = 120000;

export const STOCK_AI_ANALYSIS_DISCLAIMER_KEY = {
  SHORT: "stock_ai_analysis_generated_via_ai",
  SHOW_MORE: "show_more",
  SHOW_LESS: "show_less",
  MORE: "stock_ai_analysis_disclaimer_more"
};

export const NEW_BADGE_KEY = "badge_new";
